<template>
  <component :is="tag"
             class="s-text"
             :class="className"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SText',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'secondary', 'alternate'].includes(value)
      },
    },

    size: {
      type: String,
      default: 'm',
      validator: function (value) {
        return ['m', 's', 'xs'].includes(value)
      },
    },

    tag: {
      type: String,
      default: 'p',
    },
  },

  computed: {
    className() {
      return [`s-text--${this.variant}`, `s-text--${this.size}`]
    },
  },
}
</script>

<style scoped lang="scss">
.s-text {
  margin: 0;
  padding: 0;

  &--primary {
    color: $color-gray-400;
    font-weight: $font-weight-light;
  }

  &--secondary {
    color: $color-gray-400;
    font-weight: $font-weight-normal;
  }

  &--alternate {
    color: $color-gray-300;
    font-weight: $font-weight-light;
  }

  &--m {
    font-size: pxtorem(15);
    letter-spacing: 0px;
  }

  &--s {
    font-size: pxtorem(12);
    letter-spacing: 0.1px;
  }

  &--xs {
    font-size: pxtorem(11);
    letter-spacing: 0.1px;
  }

  &--left {
    text-align: left;
  }

  &--center {
    text-align: center;
  }

  &--right {
    text-align: right;
  }
}
</style>
